export default "__VITE_ASSET__C7jNt5xZ__"